import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import ActiveStateButton from 'components/button/ActiveStateButton';
import AddButton from 'components/button/AddButton';
import authHelper from 'helpers/auth';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Column from 'components/ui/show/Column';
import compose from 'recompose/compose';
import DeleteModalButton from 'components/button/DeleteModalButton';
import EditButton from 'components/button/EditButton';
import Header from 'components/ui/general/Header';
import ImageContainer from '../images/ImageContainer';
import ImageDropzoneField from 'components/input/Dropzone/ImageDropzoneField';
import InnerColumn from 'components/ui/show/InnerColumn';
import Notification from 'components/ui/general/Notification';
import ProductAccessPointsContainer from '../productAccessPoints/ProductAccessPointsContainer';
import ProductAvailability from 'pages/products/productAvailibity/ProductAvailability';
import ProductLocalisationShowContainer from 'pages/products/productLocalisation/show/ProductLocalisationShowContainer';
import ProductLogo from 'pages/products/show/ProductLogo';
import ProductNotActiveNotification from 'components/notifications/ProductNotActiveNotification';
import ProductRelated from 'pages/products/productRelated/ProductRelated';
import ProductResourceNotification from 'components/notifications/ProductResourceNotification';
import Properties from 'pages/products/show/Properties';
import RelatedProductModal from 'pages/products/productRelated/ProductModal';
import Section from 'components/ui/general/Section';
import ShowButton from 'components/button/ShowButton';
import SingleDataContainer from 'containers/Data/SingleDataContainer';
import TextField from 'components/show/TextField';
import Title from 'components/ui/general/Title';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { addProductImage } from 'store/actions/products/images/addImage';
import { createProductLogo } from 'store/actions/products/createProducts';
import { createProductRelated } from 'store/actions/products/related/createProductRelated';
import { deleteProductImage } from 'store/actions/products/images/deleteImage';
import { deleteProductLogoFailure, deleteProductLogoSuccess, deleteProductLogo } from 'store/actions/products/deleteProducts';
import { fetchAccount } from 'store/actions/accounts/fetchAccounts';
import { fetchProductImages } from 'store/actions/products/images/fetchImages';
import { fetchSubcategory } from 'store/actions/subcategories/fetchSubcategories';
import { setHighlightedProductImage } from 'store/actions/products/images/setHighlightedProductImage';
import { ContentCopyIcon, SettingsIcon } from 'assets/materialIcons/materialIcons';
import { updateProductActivityFailure, updateProductActivitySuccess } from 'store/actions/products/updateProducts';
import ActionButton from 'components/button/ActionButton';
import { throttle } from 'lodash';
import ProductLocation from './ProductLocation';
import ProductMembershipsContainer from '../memberships/ProductMembershipsContainer';

class ProductsShow extends React.Component {
    render() {
        const {
            addProductRelated,
            duplicate,
            id,
            location,
            record,
            translate,
        } = this.props;

        const isAdmin = authHelper.isAdmin();
        const isProvider = authHelper.isProvider();

        const breadcrumbs = [
            {
                label: translate('resources.products.title'),
                link: '/products',
            },
            {
                label: record.title,
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ record.title } />

                    <Actions>
                        { isAdmin &&
                            <ActionButton
                                icon={ <ContentCopyIcon color={ theme.palette.doveGray } /> }
                                title={ translate('actions.duplicate') }
                                onClick={ throttle(duplicate, 5000, { trailing: false }) }
                            />
                        }

                        { isAdmin &&
                            <EditButton
                                icon={ <SettingsIcon color={ theme.palette.doveGray } /> }
                                label={ translate('actions.configure') }
                                primary={ true }
                                record={ record }
                                url={ `/products/${ id }/configuration` }
                            />
                        }

                        { (isAdmin || isProvider) &&
                            <ShowButton
                                label={ translate('resources.products.actions.occupancy') }
                                url={ `/products/${ id }/occupancy` }
                            />
                        }

                        { isAdmin &&
                            <ProductAvailability
                                form='product-availability'
                                product={ record }
                            />
                        }

                        { isAdmin &&
                            <EditButton
                                label={ translate('resources.products.actions.resource') }
                                primary={ true }
                                record={ record }
                                url={ `/products/${ id }/resource` }
                            />
                        }

                        { (isAdmin || isProvider) &&
                            <ActiveStateButton
                                active={ record.enabled }
                                failureAction={ updateProductActivityFailure }
                                id={ id }
                                parameter='enabled'
                                resource='products'
                                role='product'
                                successAction={ updateProductActivitySuccess }
                            />
                        }
                    </Actions>
                </Header>

                <Notification>
                    <ProductNotActiveNotification
                        data={ record }
                        resource='products'
                    />

                    <ProductResourceNotification
                        data={ record }
                    />
                </Notification>

                <Section>
                    <Column
                        size={ 8 }
                        editEnabled={ isAdmin }
                        editRoute={ `/products/${ id }` }
                        title={ translate('resources.products.forms.general') }
                    >
                        <InnerColumn>
                            <TextField
                                label='resources.products.fields.title'
                                value={ record.title }
                            />

                            <TextField
                                label='resources.products.fields.id'
                                value={ id }
                            />
                            {
                                record.relationships &&

                                <TextField
                                    label='resources.products.fields.category_id'
                                    value={ record.relationships.category.data.name }
                                />
                            }

                            { record.subcategory_id &&
                                <SingleDataContainer
                                    action={ fetchSubcategory }
                                    id={ record.subcategory_id }
                                    resource='subcategories'
                                >
                                    { (renderProps) => {
                                        const { data } = renderProps;

                                        return <TextField
                                            label='resources.products.fields.subcategory_id'
                                            value={ data.name }
                                        />;
                                    } }
                                </SingleDataContainer>
                            }
                        </InnerColumn>
                    </Column>

                    <Column
                        actions={ isAdmin && record.logo && <DeleteModalButton
                            action={ deleteProductLogo }
                            additional='logo'
                            failureAction={ deleteProductLogoFailure }
                            id={ id }
                            record={ record }
                            resource='products'
                            successAction={ deleteProductLogoSuccess }
                            shouldRedirectToResourceList={ false }
                        /> }
                        size={ 4 }
                        title={ translate('resources.products.forms.logo') }
                    >
                        <InnerColumn>
                            { !record.logo &&
                                <ImageDropzoneField
                                    createAction={ createProductLogo }
                                    dropZoneId='product-logo'
                                    formDataKey='asset'
                                    id={ id }
                                    maxHeight={ 600 }
                                    maxWidth={ 600 }
                                />
                            }

                            { record.logo &&
                                <ProductLogo
                                    src={ record.logo }
                                    alt={ record.title }
                                />
                            }
                        </InnerColumn>
                    </Column>
                </Section>

                { isAdmin &&
                    <div>
                        <Section>
                            <Column
                                size={ 8 }
                                title={ translate('resources.products.forms.provider') }
                            >
                                <InnerColumn>
                                    <SingleDataContainer
                                        action={ fetchAccount }
                                        id={ record.provider_id }
                                        resource='accounts'
                                    >
                                        { (renderProps) => {
                                            const { data } = renderProps;

                                            return (
                                                <div>
                                                    <TextField
                                                        label='resources.products.fields.provider_id'
                                                        value={ data.name }
                                                    />

                                                    <TextField
                                                        label='resources.products.fields.email1'
                                                        value={ data.email }
                                                    />

                                                    <TextField
                                                        label='resources.products.fields.phone'
                                                        value={ record.phone || data.phone }
                                                    />
                                                </div>
                                            ) ;
                                        } }
                                    </SingleDataContainer>

                                </InnerColumn>
                            </Column>

                            <Column
                                size={ 4 }
                                editEnabled={ isAdmin }
                                editRoute={ `/products/${ id }/location` }
                                title={ translate('resources.products.forms.location') }
                            >
                                <InnerColumn>
                                    <TextField
                                        label='resources.products.fields.location_address'
                                        value={ record.location_address }
                                    />

                                    { isAdmin &&
                                        <TextField
                                            label='resources.products.fields.location_latitude'
                                            value={ record.location_latitude }
                                        />
                                    }

                                    { isAdmin &&
                                        <TextField
                                            label='resources.products.fields.location_longitude'
                                            value={ record.location_longitude }
                                        />
                                    }

                                    {
                                        isAdmin &&
                                        <ProductLocation
                                            coordinates={ {
                                                lat: record.location_latitude,
                                                lng: record.location_longitude,
                                            } }
                                        />
                                    }
                                </InnerColumn>
                            </Column>
                        </Section>

                        <Section>
                            <Column
                                actions={ <AddButton basePath={ `products/${ id }/properties` } /> }
                                title={ translate('resources.products.forms.properties') }
                            >
                                <InnerColumn>
                                    <Properties
                                        record={ record }
                                    />
                                </InnerColumn>
                            </Column>
                        </Section>

                        { isAdmin && (
                            <Section>
                                <Column
                                    actions={ <AddButton basePath={ `products/${ id }/access-points` } /> }
                                    title={ translate('resources.access_points.title') }
                                >
                                    <InnerColumn>
                                        <ProductAccessPointsContainer
                                            id={ id }
                                            resource='access-points'
                                        />
                                    </InnerColumn>
                                </Column>
                            </Section>
                        ) }

                        <Section>
                            <Column title={ 'Images' }>
                                <InnerColumn>
                                    <ImageContainer
                                        action={ fetchProductImages }
                                        createAction={ addProductImage }
                                        deleteAction={ deleteProductImage }
                                        highlightImageAction={ setHighlightedProductImage }
                                        id={ id }
                                        record={ record }
                                        showHighlightOption={ true }
                                        source='productImages'
                                    />
                                </InnerColumn>
                            </Column>
                        </Section>

                        { isAdmin &&
                            <Section>
                                <Column
                                    actions={
                                        <RelatedProductModal
                                            actionType='PRODUCTS'
                                            location={ location }
                                            productId={ id }
                                            resource='products'
                                            handleAdd={ (productRelatedId) => {
                                                return addProductRelated(productRelatedId);
                                            } }
                                        />
                                    }
                                    title={ translate('resources.products.forms.related') }
                                >
                                    <InnerColumn>
                                        <ProductRelated
                                            productId={ id }
                                        />
                                    </InnerColumn>
                                </Column>
                            </Section>
                        }

                        <Section>
                            <Column title={ translate('menu.sidebar.memberships') }>
                                <InnerColumn>
                                    <ProductMembershipsContainer
                                        id={ id }
                                        resource='product-memberships'
                                    />
                                </InnerColumn>
                            </Column>
                        </Section>

                        <Section>
                            <Column
                                editEnabled={ isAdmin }
                                editRoute={ `/products/${ id }/localisation/edit` }
                                title={ translate('resources.products.forms.content') }
                            >
                                <InnerColumn>
                                    <ProductLocalisationShowContainer
                                        data={ record }
                                        id={ id }
                                    />
                                </InnerColumn>
                            </Column>
                        </Section>
                    </div>
                }
            </div>
        );
    }
}

ProductsShow.propTypes = {
    addProductRelated: PropTypes.func.isRequired,
    duplicate: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
    record: PropTypes.shape({
        category: PropTypes.shape({
            name: PropTypes.string,
        }).isRequired,
        enabled: PropTypes.bool.isRequired,
        id: PropTypes.string.isRequired,
        location_address: PropTypes.string,
        location_latitude: PropTypes.number,
        location_longitude: PropTypes.number,
        logo: PropTypes.string,
        phone: PropTypes.string,
        provider_id: PropTypes.number,
        resource: PropTypes.shape({
            id: PropTypes.oneOfType([
                PropTypes.number,
                PropTypes.string,
            ]),
            name: PropTypes.string,
        }),
        relationships: PropTypes.shape({
            category: PropTypes.shape({
                data: PropTypes.shape({
                    name: PropTypes.string,
                }),
            }),
        }),
        subcategory_id: PropTypes.number,
        title: PropTypes.string,
    }).isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        addProductRelated: (productRelatedId) => {
            const { id } = props;

            dispatch(createProductRelated({
                productId: id,
                productRelatedId: productRelatedId,
            }));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(ProductsShow);



// WEBPACK FOOTER //
// ./src/pages/products/show/ProductsShow.js